import React from 'react';

import styled from '@emotion/styled';

import type { HomeLocationColumnGroup } from './home_location_columns';
import { MEDIA, TOKENS } from './tokens';

const StateBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${TOKENS.space[8]};
`;

const StateHeading = styled.p`
  margin: 0;
  padding-top: ${TOKENS.space[16]};
  padding-left: 2px;
  font-family: ${TOKENS.font.sans};
  font-size: 12px;
  line-height: 20px;
  font-weight: 500;
  text-transform: uppercase;
  color: ${TOKENS.color.primaryHover};

  ${MEDIA.lg} {
    padding-top: 0;
    padding-left: 0;
    font-weight: 600;
    letter-spacing: 0.08em;
    color: ${TOKENS.color.primary};
  }
`;

const CityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${TOKENS.space[12]};

  ${MEDIA.lg} {
    gap: ${TOKENS.space[4]};
  }
`;

const CityLink = styled.a`
  position: relative;
  display: inline-block;
  align-self: flex-start;
  padding-left: 2px;
  font-family: ${TOKENS.font.sans};
  font-size: 12px;
  line-height: 20px;
  font-weight: 500;
  color: ${TOKENS.color.inverse};
  text-decoration: none;

  ${MEDIA.lg} {
    padding-left: 0;
    font-size: 14px;
    line-height: 1.4;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: currentColor;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.25s ease;
  }

  &:hover::after,
  &:focus-visible::after {
    transform: scaleX(1);
  }
`;

export const HomeLocationLinks: React.FC<{
  groups: ReadonlyArray<HomeLocationColumnGroup>;
}> = ({ groups }) => (
  <>
    {groups.map((group) => (
      <StateBlock key={group.state.id}>
        <StateHeading>{group.state.name}</StateHeading>
        <CityList>
          {group.cities.map((city) => (
            <CityLink key={city.id} href={city.href}>
              {city.label}
            </CityLink>
          ))}
        </CityList>
      </StateBlock>
    ))}
  </>
);
